import React from 'react';
import '../styles/logo.css';

interface H2GOLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  className?: string;
  transparent?: boolean;
  transparentVariant?: 'default' | 'alt' | 'simple' | 'dark' | 'light';
}

const H2GOLogo: React.FC<H2GOLogoProps> = ({ 
  size = 'md', 
  showText = true, 
  className = '',
  transparent = true,
  transparentVariant = 'default'
}) => {
  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-lg',
    lg: 'text-xl',
    xl: 'text-2xl'
  };


  return (
    <div className={`flex items-center ${className}`}>
      {/* Logo Image */}
      <div className={`${sizeClasses[size]} flex-shrink-0`}>
        <img
          src="/h2go.png"
          alt="H2GO Logo"
          className={`w-full h-full object-contain`}
        />
      </div>

      {/* Brand text */}
      {showText && (
        <div className="ml-3">
          <div className={`font-bold text-gray-900 ${textSizeClasses[size]}`}>
            H2GO
          </div>
          {size === 'lg' || size === 'xl' ? (
            <div className="text-xs text-gray-600 font-medium">
              Hydration On-The-Move
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default H2GOLogo;
